export function convertToEm(cssValue: string): string {
    let temp = cssValue;

    const pxToEm = (px: string): string => {
        const value = parseFloat(px);
        return `${(value / 16).toFixed(3)}em`;
    };

    const remToEm = (rem: string): string => {
        const value = parseFloat(rem);
        return `${value.toFixed(3)}em`;
    };

    temp = temp.replace(/(\d*\.?\d+)px/g, (_match, value) => {
        return pxToEm(value);
    });

    temp = temp.replace(/(\d*\.?\d+)rem/g, (_match, value) => {
        return remToEm(value);
    });

    return temp;
}
